import { create } from "zustand";
import { type AddToCartActionStatus } from "@/app/actions/cart";

interface AddToCartErrorStore {
	status: AddToCartActionStatus | null;
	message: string | null;
	seq: number;
	fail: (status: AddToCartActionStatus, message: string) => void;
	clear: () => void;
}

export const useAddToCartErrorStore = create<AddToCartErrorStore>((set) => ({
	status: null,
	message: null,
	seq: 0,
	fail: (status, message): void =>
		set((state) => ({ status, message, seq: state.seq + 1 })),
	clear: (): void => set({ status: null, message: null })
}));
